import { RootState } from "../../../../store";
import { DashboardWidgetCostBreakdown } from "../../../../../services/cloudchipr.api";
import { widgetByIdSelector } from "../common/widgetByIdSelector";

export const costBreakdownWidgetByIdSelector = (
  state: RootState,
  widgetId?: string,
): DashboardWidgetCostBreakdown | undefined => {
  if (!widgetId) {
    return;
  }

  return widgetByIdSelector(state, widgetId) as DashboardWidgetCostBreakdown;
};
